import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import { getBasicDetails } from "../../../common/constants/api";
import get from "lodash/get";
import { setUserName } from "../../../common/utils/cookie-utils";
import {
	UserKycStatus,
	obj,
	navItemsForkyc,
} from "../../../common/userData/UserKycStatus";
import Stepper from "../../../components/Stepper/Stepper";
import Steps from "./Steps";
import Chevron from "../../../images/icons/arrow_down.svg";
import FormikWizard from "formik-wizard";
import moment from "moment";
import CustomSideBar from "../../../common/components/Sidebar/Sidebar";
import Header from "../../../common/components/Header/Header";
import CircularLoading from "../../../common/components/CircularLoading/CircularLoading";
import { navigate } from "gatsby";

let stepsText = [
	"Sign in",
	"Basic Details",
	"Constitution",
	"Profession",
	"PAN",
	"Aadhaar",
	"Address Proof",
	"Selfie",
	"Bank Details",
	"References",
];
const icons = {
	1: <div className="text-lg">1</div>,
	2: <div className="text-lg">2</div>,
	3: <div className="text-lg">3</div>,
	4: <div className="text-lg">4</div>,
	5: <div className="text-lg">5</div>,
	6: <div className="text-lg">6</div>,
	7: <div className="text-lg">7</div>,
	8: <div className="text-lg">8</div>,
	9: <div className="text-lg">9</div>,
	10: <div className="text-lg">10</div>,
};
function FormWrapper({
	formikProps,
	children,
	currentStep = "selfie",
	isLastStep,
	status,
	goToPreviousStep,
	canGoBack,
	steps,
	step,
	wizard,
	actionLabel,
}) {
	const [renderState, setRenderState] = useState(false);
	const [navItems, setNavItems] = useState([]);
	useEffect(() => {
		setNavItems(navItemsForkyc);
	}, []);
	const ChevronLeft = () => (
		<img
			className="h-4 block"
			src={Chevron}
			style={{ transform: "rotate(90deg)" }}
		/>
	);
	let res = [];
	async function fetchAndPush() {
		let data = await UserKycStatus();
		let updateStep = 0;
		res = Object.entries(data);
		for (let i = 0; i < res.length; i++) {
			if (res[i][1] === "NOT_INITIATED") {
				if (i == 0) {
					updateStep = i;
					break;
				} else {
					i > 0;
					{
						updateStep = i + 4;
						break;
					}
				}
			} else {
				updateStep = 10;
			}
		}
		if (obj.isFirstLoadKYC) {
			obj.isFirstLoadKYC = false;
			wizard.push(steps.find((_, i) => i === updateStep));
		}
		setRenderState(true);
	}
	function goPrevious() {
		let currStepIndex = wizard.steps.indexOf(wizard.step);
		wizard.push(steps[currStepIndex - 1]);
	}
	useEffect(() => {
		fetchAndPush();
	}, []);

	if (renderState) {
		return (
			<div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0">
				<div className=" min-h-screen flex pt-17 md:pt-0">
					<CustomSideBar navItems={navItems} />
					<div className="flex-1  w-full widhtMd max-screen">
						<Header />
						<div className="flex-1 pb-8 flex-row w-full relative">
							<div className="overflow-x-auto">
								<Stepper
									activeStep={wizard.steps.indexOf(wizard.step) + 1}
									stepsText={stepsText}
									stepIcons={icons}
								/>
							</div>
							<div>
								{/* ///comment befour push code/ */}
								{/* 
                {canGoBack && !isLastStep ? (
                  <button
                    type="button"
                    onClick={goPrevious}
                    disabled={!canGoBack}
                    style={{
                      position: 'absolute',
                      outline: '0',
                      left: '10%',
                      marginTop: '20px'
                    }}
                  >
                    {ChevronLeft()}
                  </button>
                ) : null} */}
								{/* //comment befour push code/// */}
							</div>
							{/* step is OTP isChangeNoNeed =  */}
							{children}
						</div>
					</div>
				</div>
			</div>
		);
	} else {
		return <CircularLoading />;
	}
}
const dashboard = () => {
	const handleSubmit = React.useCallback((values) => {
		console.log("full values:", values);

		return {
			message: "Thanks for submitting!",
		};
	}, []);
	const [updatedSteps, updateSteps] = useState(Steps);
	useEffect(() => {
		const getUserData = async (Steps) => {
			try {
				const userDetails = await getBasicDetails();
				setUserName(userDetails?.name?.firstName || "");
				updateSteps(
					Steps.map((step) => {
						if (step.id === "basicDetails") {
							step.initialValues.Name = userDetails?.name?.firstName || "";
							step.initialValues.lastName = get(
								userDetails || {},
								"name.lastName",
								""
							);
							let year = moment(get(userDetails || {}, "dob", "")).year();
							let month = moment(get(userDetails || {}, "dob", "")).month();
							let date = moment(get(userDetails || {}, "dob", "")).date();
							let current_year = parseInt(moment().format("YYYY"));

							step.initialValues.email = get(userDetails || {}, "email", "");
							step.initialValues.mobile = get(userDetails || {}, "phone", "");
							step.initialValues.pincode =
								userDetails?.addressResidence?.pinCode || "";
							step.initialValues.year = {
								value: year ? year : String(current_year - 18),
								label: year ? year : String(current_year - 18),
							};
							step.initialValues.month = {
								value: month
									? moment()
											.month(month)
											.format("MMMM")
									: "",
								label: month
									? moment()
											.month(month)
											.format("MMMM")
									: "Month",
							};
							step.initialValues.date = {
								value: date ? date : "",
								label: date ? date : "Date",
							};
						}
						return step;
					})
				);
			} catch (err) {
				navigate("/app/logout");
				return err.message;
			}
		};
		getUserData(Steps);
	}, [Steps]);
	return (
		<FormikWizard
			steps={updatedSteps}
			onSubmit={handleSubmit}
			render={FormWrapper}
		/>
	);
};
export default dashboard;
